import { filterState } from './AddressesHelper';

export const getAddressTextPe = (address, regions) => {
  const districts = [];
  const stateFiltered = filterState(address, regions);
  if (!stateFiltered.length) return '';
  const cityFiltered = stateFiltered[0].children.filter(function (district) {
    const districtFiltered = district.children.filter(function (city) {
      return city.id.toString() === address.city;
    });
    if (districtFiltered.length) {
      districts.push(districtFiltered[0]);
      return district;
    }
  });
  if (!cityFiltered.length) return stateFiltered[0].name;
  if (!districts.length)
    return `${stateFiltered[0].name}, ${cityFiltered[0].name}`;
  return `${stateFiltered[0].name}, ${cityFiltered[0].name}, ${districts[0].name}`;
};

export const definePhoneNumberToAddressPe = (state) => ({
  phone1: state['phone'].value.toString(),
});

export const returnProvidenceIdPe = (address, regions) => {
  const stateFiltered = filterState(address, regions);
  if (!stateFiltered.length) return '';
  const providenceFiltered = stateFiltered[0].children.filter(function (
    district,
  ) {
    const districtFiltered = district.children.filter(function (city) {
      return city.id.toString() === address.city;
    });
    if (districtFiltered.length) {
      return district;
    }
  });
  if (!providenceFiltered.length) return '';
  return providenceFiltered[0].id.toString();
};
